module.exports = __webpack_public_path__ + "img/waterpurifier26.bbe98330.jpg";